'use client';
const LimitedQueue = (options)=>{
    const { limit } = options;
    let queue = [];
    const limitedQueue = {
        push,
        getLength,
        shift,
        isEmpty,
        clear
    };
    function push(element) {
        if (queue.length + 1 > limit) {
            queue.shift();
        }
        queue.push(element);
    }
    function shift() {
        return queue.shift();
    }
    function getLength() {
        return queue.length;
    }
    function isEmpty() {
        return getLength() == 0;
    }
    function clear() {
        queue = [];
    }
    return limitedQueue;
};

export { LimitedQueue };
//# sourceMappingURL=LimitedQueue.js.map
